export enum TeamOwnerType {
    Internal = 1,
    External = 2,
}

export const TeamOwnerTypeLabels = {
    [TeamOwnerType.Internal]: "Sveaskog",
    [TeamOwnerType.External]: "Entreprenör"
}